import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "category-navigation" };
const _hoisted_2 = { class: "categories-title" };
const _hoisted_3 = { class: "category-grid" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "category-icon" };
const _hoisted_6 = { class: "emoji-icon" };
const _hoisted_7 = { class: "category-info" };
const _hoisted_8 = { class: "category-name" };
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryNavigation',
    props: {
        categories: {},
        selectedCategory: {}
    },
    emits: ["category-change"],
    setup(__props) {
        const props = __props;
        const sortedCategories = computed(() => {
            const activeCategories = (props.categories || []).filter((category) => !!category.isActive);
            return [...activeCategories].sort((a, b) => Number(a.ordered) - Number(b.ordered));
        });
        const getCategoryIcon = (categoryId) => {
            const category = props.categories.find((cat) => cat.id === categoryId);
            if (!category)
                return "🍽️";
            const categoryName = category.name.toLowerCase();
            const iconMap = {
                pâtes: "🍝",
                pasta: "🍝",
                salades: "🥗",
                salad: "🥗",
                pizza: "🍕",
                pizzas: "🍕",
                sandwich: "🥪",
                sandwiches: "🥪",
                boisson: "🥤",
                boissons: "🥤",
                beverages: "🥤",
                dessert: "🍰",
                desserts: "🍰",
                panzerotti: "🥟",
                entrée: "🍤",
                entrées: "🍤",
                appetizer: "🍤",
                appetizers: "🍤",
                breakfast: "🥓",
                lunch: "🍔",
                dinner: "🍗",
                soup: "🍲",
                sidedish: "🌶️",
                "side dish": "🌶️",
                plats: "🍽️",
                dishes: "🍽️",
                menu: "🍽️",
            };
            for (const [key, icon] of Object.entries(iconMap)) {
                if (categoryName.includes(key) || key.includes(categoryName)) {
                    return icon;
                }
            }
            return "🍽️";
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('pages.categoryList')), 1),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCategories.value, (category) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: category.id,
                            class: _normalizeClass(['category-card', { active: __props.selectedCategory === category.id }]),
                            onClick: ($event) => (_ctx.$emit('category-change', category.id))
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(getCategoryIcon(category.id)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("h3", _hoisted_8, _toDisplayString(category.name.charAt(0).toUpperCase() + category.name.slice(1)), 1)
                            ])
                        ], 10, _hoisted_4));
                    }), 128))
                ])
            ]));
        };
    }
});
